export const contractVerifiedHints = {
  license: 'License information of the smart contract.',
  compiler: 'Compiler version used for the smart contract.',
  entryFile: 'Main file of the smart contract source code',
  verifiedAt: 'Timestamp when the smart contract was verified.',
  initCallParameters: 'Initial call parameters of the smart contract.',
  connectWallet: 'Connect your wallet to execute write action to smart contract.',
}
